import * as React from "react";
import "./index.scss";

const Input = ({
  value,
  onChange,
  placeholder,
  name,
  label,
  type,
  className,
  disabled,
  onBlur,
  isRequired = false,
  isError,
  ...rest
}) => {
  return (
    <div className={`input-container ${className}`}>
      {label && (
        <label className="input-label" htmlFor={name}>
          {label}
          {isRequired && <span className="star">*</span>}
        </label>
      )}
      <input
        className={`w-100 px-3 py-2 ${
          isError ? "error-input" : ""
        }`}
        name={name}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        id={name}
        disabled={disabled}
        onBlur={onBlur}
        {...rest}
      />
    </div>
  );
};

export default Input;
